import { c as _c } from "react/compiler-runtime";
import { forwardRef } from 'react';
import Grid from '../../Grid';
import { type MessageCardProps } from './types';
import UserMessageCard from './Cards/UserMessageCard';
import SystemMessageCard from './Cards/SystemMessageCard';
import CopilotMessageCard from './Cards/CopilotMessageCard';
export const MessageCard = forwardRef<HTMLDivElement, MessageCardProps>((t0, ref) => {
  const $ = _c(12);
  const {
    message
  } = t0;
  switch (message.messageType) {
    case "custom":
      {
        let t1;
        if ($[0] !== message.content || $[1] !== ref) {
          t1 = <Grid ref={ref}>{message.content}</Grid>;
          $[0] = message.content;
          $[1] = ref;
          $[2] = t1;
        } else {
          t1 = $[2];
        }
        return t1;
      }
    case "copilot":
      {
        let t1;
        if ($[3] !== message || $[4] !== ref) {
          t1 = <CopilotMessageCard message={message} ref={ref} />;
          $[3] = message;
          $[4] = ref;
          $[5] = t1;
        } else {
          t1 = $[5];
        }
        return t1;
      }
    case "system":
      {
        let t1;
        if ($[6] !== message || $[7] !== ref) {
          t1 = <SystemMessageCard message={message} ref={ref} />;
          $[6] = message;
          $[7] = ref;
          $[8] = t1;
        } else {
          t1 = $[8];
        }
        return t1;
      }
    case "user":
      {
        let t1;
        if ($[9] !== message || $[10] !== ref) {
          t1 = <UserMessageCard message={message} ref={ref} />;
          $[9] = message;
          $[10] = ref;
          $[11] = t1;
        } else {
          t1 = $[11];
        }
        return t1;
      }
  }
});
export default MessageCard;